import { Component, ErrorInfo, ReactNode } from 'react';
import { Backdrop, Button } from '@mui/material';
import Logo from './Logo';
import { Navigate } from 'react-router-dom';

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean;
  redirect: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    redirect: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: ErrorInfo) {
    console.error(error);
    console.debug(info.componentStack);
  }

  handleReset = () => {
    this.setState({
      redirect: true,
      hasError: false,
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Backdrop
          sx={{
            zIndex: theme => theme.zIndex.drawer + 1,
            backgroundColor: '#ffffff',
            flexDirection: 'column',
          }}
          open={ true }
        >
          { this.state.redirect && <Navigate to="/" /> }
          <Logo sx={{ mb: '2rem' }} />
          <strong>Se produjo un error inesperado</strong>
          <br />
          <Button onClick={ this.handleReset }>Volver al inicio</Button>
        </Backdrop>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
